module.exports = __webpack_public_path__ + "media/images/estrela-amarela-a284da2af2d0607af9e8035847845ae5.svg";